export const timingFunction = {
  base: 'cubic-bezier(0.4, 0, 0.2, 1)',
};
